import React from "react";
import { CMSData } from "@/cms/models";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ApplicationDataType } from "@/services/queries/get-application-details";

interface StoreSelectProps {
  cmsData: CMSData;
  label: string;
  name: string;
  stores: ApplicationDataType["stores"];
}

const StoreSelect: React.FC<StoreSelectProps> = ({
  cmsData,
  name,
  stores,
  label,
}) => {
  if (!stores || stores.length === 0) {
    return <input type="hidden" name={name} defaultValue="" />;
  }

  const style = cmsData.forms.style;
  const renderSelect = (variant: any) => (
    <FormControl
      size={style?.size}
      variant={variant}
      fullWidth
      className="col-span-6"
    >
      <InputLabel>{label}</InputLabel>
      <Select required={true} variant={variant} label={label} name={name}>
        {stores.map((store, index) => (
          <MenuItem key={index} value={store.id}>
            <span className="block truncate homepage-text-sm group-data-[selected]:font-semibold">
              {store.displayName}
            </span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  if (stores.length === 1) {
    return <input type="hidden" name={name} defaultValue={stores[0].id} />;
  }
  switch (style?.type) {
    case "material-outlined":
      return renderSelect("outlined");
    case "material-standard":
      return renderSelect("standard");
    default:
      return renderSelect("filled");
  }
};

export default StoreSelect;
